import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import Highcharts from 'highcharts/highcharts';
import { isEqual } from 'lodash';
@Component({
    selector: 'app-doughnut-status',
    templateUrl: './doughnut-status.component.html',
    styleUrls: ['./doughnut-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DoughnutStatusChartComponent implements OnChanges, OnDestroy, AfterViewInit {

  @Input() markers: {data: number[], colors?: string[]};
  @Output() chartClick = new EventEmitter<any>();
  chartId: string = 'doughnut-status-' + Math.random().toString(36).substring(2, 9);

  chartOptions: Highcharts.Options;

  chart: Highcharts.Chart | undefined;
  chartSize = 100;
  series: any;

  ngOnChanges(changes): void {
    if (changes.markers.currentValue && !changes.markers.firstChange) {
      const series = this.markers.data.map((item: number, index: number) => ({
        y: item,
        color: this.markers.colors?.[index]
      }));
      if(!isEqual(this.series, series)) {
        this.series = series;
        this.createChart(series);
      }
    }
  }

  ngAfterViewInit(): void {
    this.createChart([]);
  }


  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  private createChart(series): void {
    const self = this;
    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'pie',
        height: this.chartSize,
        width: this.chartSize,
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: 0,
        spacingBottom: 0,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        renderTo: this.chartId,
        animation: false,

      },
      title: {
        text: null
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        pie: {
          innerSize: '85%',
          size: this.chartSize - 1,
          dataLabels: {
            enabled: false
          },
          inactiveOtherPoints: false,
          states: {
            hover: {
              enabled: false,
            }
          },
          borderWidth: 1,
          borderColor: 'rgba(9, 55, 112, 1)',
          borderRadius: 0,
          point: {
            events: {
              click: function()  {
                self.chartClick.emit(this);
              }
            }
          }
        },
        series: {
          enableMouseTracking: true,
          animation: false,
          shadow: false,
          marker: {
            enabled: false
          },
        },
      },
      tooltip: {
        enabled: false,
        shadow: false
      },
      boost: {
        useGPUTranslations: true
      },
      series: [{
        type: 'pie',
        data: series,
      }],
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
    };

    this.chart = Highcharts.chart(this.chartId, chartOptions);
  }

 
}
